import type { ChangelogEntry } from "../types";

/** Kundekort v3: roligere topp med logo og faktagrid, GEEK-fliser, ett kortspråk og korte tomtilstander. */
export const KUNDEKORT_V3_2026_10: ChangelogEntry = {
  id: "2026-10-19-kundekort-v3",
  date: "2026-10-19",
  title: "Kundekortet er ryddet: logo og fakta øverst, GEEK-tall til høyre, og tomme seksjoner tar én linje",
  summary:
    "Toppen viser kundens logo, navn og nettside, og et faktagrid med status, eier, kontakt og siste kjøp. Nøkkeltallene er fire GEEK-fliser: i pipe, levert, i arbeid og timepris. Alle seksjoner har samme kortform, og en seksjon uten innhold er bare en overskrift med en kort forklaring.",
  sections: [
    {
      heading: "Toppen av kundekortet",
      items: [
        {
          title: "Logo fra kundens nettside",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Har kunden en nettside i Brønnøysund, hentes nettsidens ikon automatisk om natten og vises øverst på kortet. Uten ikon vises initialene som før.",
        },
        {
          title: "Status, eier, kontakt og siste kjøp som fakta",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Den travle metalinjen er byttet ut med fire kolonner: Status (med når kunden kjølner), Eier (avatarer og fornavn), Kontakt (hovedkontakt med tittel) og Siste kjøp (dato, prosjekt og beløp). «Overstyr», «endre» og «send e-post» ligger som små lenker under hver.",
        },
        {
          title: "GEEK-fliser i stedet for pipe-kortet",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Fire fliser: «GEEK i pipe nå» (bruttofortjeneste i sendte tilbud, vektet med sannsynlighet), «GEEK levert» (på avsluttede prosjekter, med andel av kontrakt), «GEEK i arbeid» (estimert på pågående) og «Timepris reell». Alt er bruttofortjeneste, ikke omsetning.",
        },
      ],
    },
    {
      heading: "Seksjonene",
      items: [
        {
          title: "Ett kortspråk og korte tomtilstander",
          kind: "forbedret",
          featureFlag: "feature_crm_kundekort",
          body: "Neste steg, Tilbud ute, Løpende avtaler, Det vi har laget og alt i sidekolonnen har samme ramme, topplinje og handlinger. En tom seksjon er én linje som sier hva som mangler og hvor det lages, i stedet for et tomt kort med forklaring.",
        },
        {
          title: "Overvåkning leses som et kort, redigeres i en dialog",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Kildene vises som lesbare rader med adresse, frekvens, siste kjøring og status, og Brønnøysund står som egen rad. Brytere, adresser og frekvens ligger bak «Rediger kilder».",
        },
        {
          title: "GEEK reell i prosjekttabellen",
          kind: "forbedret",
          body: "Kolonnen «BF reell» i «Det vi har laget» heter nå «GEEK reell», samme tall som før.",
        },
      ],
    },
  ],
};
